import {
    Component,
    Input,
    OnInit,
  } from '@angular/core';
  import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
  import { LookupService } from '../../../../services/lookup.service';
  import { TimesheetService } from '../../../../services/timesheet.service';
  import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TableModule } from 'primeng/table';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { UserService } from '../../../../services/user.service';
import { environment } from '../../../../../environments/environment';
  
  @Component({
    selector: 'ppl-timesheet-staff-deniedreasons',
    standalone: true,
    imports: [
        CommonModule,
        NgZorroModule,
        ReactiveFormsModule,
        NzDatePickerModule,
        FormsModule,
        TableModule,
        NzTimePickerModule,
        NzToolTipModule
    ],
    templateUrl: './timesheet-staff-deniedreasons.component.html',
    styleUrl: './timesheet-staff-deniedreasons.component.css',
  })
  export class TimesheetStaffDeniedReasonsComponent implements OnInit {

    programName!: string;
    isExternal = false;
    @Input() deniedData: any;
    @Input() disabled: boolean = false;

    constructor(
        private fb: FormBuilder,
        private lookupService: LookupService,
        private timesheetService: TimesheetService,
        private userService: UserService
      ) {
      }

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.programName = selectedProgram?.program_code ?? '';
        this.isExternal = environment.isExternal;
    }
  }